import PropTypes from 'prop-types';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';
import { Card, Row, Col, Form } from 'react-bootstrap';

const TimesheetApproval = ({
  isTsheeApprovalEnabled,
  handleUpdateTSApproval,
}) => {
  // eslint-disable-next-line no-console
  console.log(isTsheeApprovalEnabled);
  return (
    <Formik
      initialValues={{
        timesheetApproval: isTsheeApprovalEnabled,
      }}
      enableReinitialize
      validationSchema={Yup.object({
        isTsheeApprovalEnabled: Yup.boolean(),
      })}
      onSubmit={(values) => {
        handleUpdateTSApproval(values);
      }}
    >
      {(formikprops) => (
        <div className="col-12 col-md-12">
          <Form
            onSubmit={formikprops.handleSubmit}
            className="needs-validation"
          >
            <Card>
              <Card.Body>
                <h6 className="text-uppercase text-muted mb-2">
                  Timesheet approval Settings
                </h6>
                <Row>
                  <Col>
                    <div className="form-check ">
                      <Field
                        className="form-check-input form-check-border"
                        name="timesheetApproval"
                        type="checkbox"
                        onChange={(e) => {
                          formikprops.setFieldValue(
                            'timesheetApproval',
                            !formikprops.values.timesheetApproval
                          );

                          handleUpdateTSApproval({
                            timesheetApproval: e.target.checked,
                          });
                        }}
                        checked={formikprops.values.timesheetApproval}
                      />
                      <Form.Label className="form-check-label ">
                        Enable timesheet approval
                      </Form.Label>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Form>
        </div>
      )}
    </Formik>
  );
};
TimesheetApproval.propTypes = {
  isTsheeApprovalEnabled: PropTypes.bool,
  handleUpdateTSApproval: PropTypes.func,
};
export default TimesheetApproval;
